import { useRequest } from 'ahooks';
import { getTrades } from '../../api';
import TradeList from '../TradeList';
import { Box, Theme, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import ArrowRight from '../icons/ArrowRight';
import Link from 'next/link';
import classNames from 'classnames';

export default function Swaps() {
	const { run, data, loading } = useRequest(getTrades);
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	const [page, setPage] = useState(1);

	useEffect(() => {
		run({ page: page - 1 });
	}, [page, run]);

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
			{!isMobile && (<Box className="select-none flex items-center gap-3 h-12 px-6 xs:px-3">
				<Link href={'/'} className={classNames('text-textSecondary hover:text-textPrimary no-underline transition-colors')}>
					<ArrowRight sx={{ transform: 'rotate(-180deg)' }} className='mr-3' />
					<Typography variant='appMediumRegular' className='align-middle'>Dashboard</Typography>
				</Link>
			</Box>)}
			<TradeList
				loading={loading}
				data={data?.data}
				count={data?.pageCount ?? 0}
				onPageChange={setPage}
				page={page}
			/>
		</Box>
	);
}
